import { HELP } from 'externalUrls'

import { accessZendeskLoggedIn } from 'utils/sdks/zendesk'

export const HELP_TEXT = 'See Help Center Article'
export const HELP_LINK = accessZendeskLoggedIn(
  HELP + '/articles/25548564601371-Move-Products',
)
